'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = chathistoryMiddleware;

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function chathistoryMiddleware() {
    return function middleware(client, rawEvents, parsedEvents) {
        client.requestCap('CHATHISTORY');
        addFunctionsToClient(client);
        parsedEvents.use(theMiddleware);
    };

    function theMiddleware(command, event, client, next) {
        if (command.toLowerCase() === 'batch end chathistory' && client.chathistory) {
            var target = event.params[0];
            client.chathistory.batchCallbacks.resolve(target, event);
        }

        if (command.toLowerCase() === 'fail' && event.params[0].toLowerCase() === 'chathistory') {
            if (event.params[1].toLowerCase() === 'message_error') {
                client.chathistory.batchCallbacks.resolve(event.params[3]);
            }
        }

        next();
    }
}

function addFunctionsToClient(client) {
    var history = client.chathistory = {};

    history.batchCallbacks = {
        callbacks: (0, _create2.default)(null),
        add: function add(target, cb) {
            this.callbacks[target.toLowerCase()] = this.callbacks[target.toLowerCase()] || [];
            this.callbacks[target.toLowerCase()].push(cb);
        },
        resolve: function resolve(target, value) {
            var cbs = this.callbacks[target.toLowerCase()] || [];
            delete this.callbacks[target.toLowerCase()];
            cbs.forEach(function (cb) {
                return cb(value);
            });
        },
        targetCallbacks: function targetCallbacks(target) {
            return this.callbacks[target.toLowerCase()];
        }
    };

    history.isSupported = function () {
        return !!client.network.supports('chathistory');
    };

    history.before = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'BEFORE', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.after = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'AFTER', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.latest = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'LATEST', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.around = function (target, dateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            client.raw('CHATHISTORY', 'AROUND', target, messageReference(dateOrTime), '50');
            history.batchCallbacks.add(target, resolve);
        });
    };

    history.between = function (target, fromDateOrTime, toDateOrTime) {
        return new _promise2.default(function (resolve) {
            if (!history.isSupported()) {
                resolve();
                return;
            }

            var fromRef = messageReference(fromDateOrTime);
            var toRef = messageReference(toDateOrTime);
            client.raw('CHATHISTORY', 'BETWEEN', target, fromRef, toRef, 50);
            history.batchCallbacks.add(target, resolve);
        });
    };

    function messageReference(inp) {
        if ((typeof inp === 'undefined' ? 'undefined' : (0, _typeof3.default)(inp)) === 'object') {
            return 'timestamp=' + Misc.dateIso(inp);
        }

        if (inp === '*') {
            return '*';
        }

        return 'msgid=' + inp;
    }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ChathistoryMiddleware"]
window._kiwi_exports.libs.ChathistoryMiddleware = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/ChathistoryMiddleware.js
// module id = G7fu
// module chunks = 1